﻿{
  "community": {
    "name": "Community",
    "titles": {
      "1": "Online-Community",
      "2": "Materialien suchen",
      "3": "Ergebnisse mit anderen teilen"
    },
    "body": {
      "1": "Eine tolle Möglichkeit, aus dem Vollen zu schöpfen und sich anzusehen, was Boardmaker zu bieten hat",
      "2": "Hier sehen Sie, was andere geschaffen und hochgeladen haben. Es ist wie ein Fenster, das den Blick auf die Magie von Boardmaker freigibt!",
      "3": "Sie können mit Ihrer bewährten Boardmaker-Software hochladen, was Sie geschaffen haben, und mit der Community teilen."
    }
  },
  "personal": {
    "name": "Einzellizenz",
    "header": "Umfasst alle Community-Funktionen plus:",
    "titles": {
      "1": "Erstellen, bearbeiten, ausführen und ausdrucken",
      "2": "Boardmaker-Software"
    },
    "body": {
      "1": "Für Eltern oder Betreuer mit Kind, die Aktivitäten erstellen, bearbeiten, ausführen und ausdrücken möchten",
      "2": "Zu den Konten gehört eine Lizenz für Boardmaker 7, die auf bis zu 2 Computern installiert werden kann."
    }
  },
  "professional": {
    "name": "Expertenlizenz",
    "header": "Umfasst alle Funktionen der Einzellizenz plus:",
    "titles": {
      "1": "Schülerverwaltung",
      "2": "Individuelle Einstellungen"
    },
    "body": {
      "1": "Für Betreuer mit 1 bis 50 Lernenden, die Aufgaben zuweisen und die Daten der Lernenden nachverfolgen möchten",
      "2": "Personalisierte Zugriffsberechtigungen für einzelne Lernende"
    }
  },
  "organization": {
    "name": "Organisation",
    "header": "Umfasst alle Funktionen der Expertenlizenz plus:",
    "titles": {
      "1": "Interdisziplinäres Supportteam"
    },
    "body": {
      "1": "Mengenrabatte, Datensteuerung durch die Organisation und mehrere Zuweisungsberechtigte für dieselben Lernenden"
    }
  }
}
